import AboutUnisearchBanner from "@modules/study/common/about_unisearch_banner/about_unisearch_banner";
import FAQSection from "@modules/study/common/sections/faq";
import ExamBanner2 from "@modules/study/exam/exam_banner2";
import ExamPreparationLists from "@modules/study/exam/exam_preparation_lists";
import { LayoutMain } from "@unisearch/theme/layout";

const faqData = [
  {
    id: 1,
    faqQuestion: "Which TOEFL test should I take?",
    faqAnswer: `<p>This depends on several factors. If you’re aiming for high academic qualifications and specialising in a scholarly or technical field, TOEFL iBT might suit you best. This features 100% academic content in its testing and specifically evaluates your ability in English against academic standards. For students seeking a more balanced approach between educational and social contexts, the TOEFL Essentials test may work better. This balances out the content between academic and non-academic material. </p><p>Nonetheless, which test you need to take might ultimately come down to what your chosen university or program is looking for. In some cases, schools exclusively ask for TOEFL iBT scores. Be sure to look into the requirements before making your choice!
    </p>`,
  },
  {
    id: 2,
    faqQuestion: "Which English proficiency test is easiest?",
    faqAnswer: `<p>This is quite subjective and the answers can vary a lot for different people. To figure out which test you have an easier time scoring in, we recommend trying out practice questions from each of the tests! These often come with score guides and other resources to help you figure out how you’d do in the real thing.</p>`,
  },
  {
    id: 3,
    faqQuestion: "Which is better, IELTS or PTE?",
    faqAnswer: `<p>“Better” is a matter of option as well as a matter of preference. “Should I take the IELTS or PTE?” boils down to your circumstances and preferences. Do you want to sit the full thing in one sitting? Then a PTE Academic test would be better for you. Do you think you’ll get a better evaluation if your Writing and Speaking sections go through a person rather than a computer? Then the IELTS might be better for you. If you don’t have access to a test centre nearby, meanwhile, the IELTS Online option starting 2022 will let you sit the test at home. It’s best to consider all the options available to you before making your decision. The IELTS, TOEFL, and PTE Academic exams each have their own distinct formats and structures. What works best for you does, in the end, depend on you!</p>`,
  },
];

const Exams = () => {
  return (
    <LayoutMain
      footer_with_evaluation
      title="Exams"
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/exams`}
    >
      <ExamBanner2 />

      <AboutUnisearchBanner
        heading={` How UniSearch Helps With Your Application <span className="mark">Admissions Exams</span>`}
        shortDescription="From English language proficiency test scores to aptitude tests like the GMAT and GRE, we have you covered to get your skills where they need to be to ace your university applications."
      />
      <ExamPreparationLists />
      <FAQSection title="Frequently Asked Questions (FAQs)" faqData={faqData} />
    </LayoutMain>
  );
};

export default Exams;
